import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '$icons/simera-dark logo.svg';
import Home from '../../Home/Home';
import classes from './LoginScreen.module.css';
import SimeraLoginForm from '../../LoginForm/SimeraLoginForm';

const SimeraLoginScreen = () => {
  const [t] = useTranslation('global');
  return (
    <Home>
      <div className={classes.SimeraContainer}>
        <div data-testid="login-header" className={classes.loginHeader}>
          <p className={classes.loginHeader}>
            {t('employeeLoginScreen.login')}
          </p>
          <div className={classes.loginHeaderDivider} />
        </div>
        <div className={classes.loginCard}>
          <Logo className="m-auto w-56 h-auto" />
          <SimeraLoginForm />
        </div>
      </div>
    </Home>
  );
};

export default SimeraLoginScreen;
